import React        from 'react';
import PropTypes    from 'prop-types';
import {
    Base,
    Check,
    Container,
    Label,
    SubLabel,
    Wrapper
}                   from './components'; 


export class Checkbox extends React.Component{
    constructor(props){
        super(props);
        this.state={
            checked: this.props.isChecked
        }
        this.handleChange = this.handleChange.bind(this);
    }
    
    componentDidUpdate(prevProps) {
        if(prevProps.isChecked !== this.props.isChecked) {
            this.setState({
                checked: this.props.isChecked
            })
        }
    }

    handleChange(e) {
        const p           = this.props;
        const s           = this.state;

        if(!p.isDisabled) {
            const isChecked = !s.checked;

            this.setState({
                checked: isChecked
            }, () => {
                if(typeof p.onChange === 'function'){
                    p.onChange(isChecked, e);
                }
            });
        }
    }

    isChecked() {
        const p = this.props;
        const s = this.state;
        return p.isChecked !== undefined
                    ? p.isChecked 
                    : s.checked;
    }

    createComponentClasses() {
        let {
            className,
            isSelector
        } = this.props;

        let classNames = [];
        if (isSelector)         classNames.push('selector');
        if (className)      Array.prototype.push.apply(classNames, className.split(' '));

        return [...new Set(classNames)].join(' ');
    }

    render() {
        const p = this.props;
        return(
            <Container 
                className           = { this.createComponentClasses() }
                onClick             = { (e) => this.handleChange(e) }
                isChecked           = { this.isChecked() }
                attrs               = { p.attrs }
            >
                <Wrapper>
                    <Base 
                        onChange    = { (e) => this.handleChange(e) }
                        isChecked   = { this.isChecked() }
                    />
                    <Check
                        isChecked        = { this.isChecked() } 
                        isSelector       = { p.isSelector }
                    />
                    <Label>
                        { p.label }
                        <SubLabel>
                            { p.subLabel }
                        </SubLabel>
                    </Label>
                </Wrapper>
            </Container>
        )
    }
}

Checkbox.propTypes = {
    label           : PropTypes.oneOfType([ PropTypes.string, PropTypes.array ]),
    subLabel        : PropTypes.oneOfType([ PropTypes.string, PropTypes.array ]),
    isSelector      : PropTypes.bool,
    attrs           : PropTypes.object,
    className       : PropTypes.string,
    value           : PropTypes.any,
    isChecked       : PropTypes.oneOfType([ PropTypes.bool, PropTypes.number ]),
    onChange        : PropTypes.func,
};

Checkbox.defaultProps = {
    label           : '',
    subLabel        : '',
    isSelector      : false,
    attrs           : {},
    className       : '',
    value           : '',
    isChecked       : false,
    onChange        : () => {},
};

export default Checkbox;